import React, { useEffect, useState } from 'react'
import { TextMediumBase, TextMediumSM } from '../../../../Components/Text/MediumText'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton, CancelButton, CreateButton, SubmitButton } from '../../../../Components/Utils/Buttons'
import axiosInstance from '../../../../Services/axiosCommon'
import { useFormik } from 'formik'
import UseEditData from '../../../../Components/Hooks/useEditData'
import { BellDot } from 'lucide-react'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'
import { GetAccess } from '../../../../Components/Utils/roles'

function MainNotification() {
  const [data, setData] = useState([])
  const [groupedData, setGroupedData] = useState({})
  const { Oncancel, editData, isLoading } = UseEditData();

  function getData() {
    axiosInstance.get(`/alert-settings/action`).then(res => {
      setData(res?.data?.data)
      const grouped = groupByModule(res?.data?.data);
      setGroupedData(grouped);
    }).catch(err => {
      console.log(err);
    })
  }

const groupByModule = (data) => {
  return data.reduce((acc, item) => {
    let module = item.name.split('_')[0];
    
      if (module === 'copy') {
        if (item.name.includes('task')) {
        module = 'task';
      } else if (item.name.includes('ticket')) {
        module = 'ticket';
      }
    } else if (module === 'reassigne') {
      module = 'reassign';
    } else if (module === 'delete') {
        module = item.name.split('_')[1];
    }
    
    if (!acc[module]) {
      acc[module] = [];
    }
    acc[module].push(item);
    return acc;
  }, {});
};
  useEffect(() => {
    getData()
  }, [])

  function handleChange(event, name, id) {
    const updatedData = data.map((item) =>
      item.name === name && item.id === id ? { ...item, isDefault: event.target.checked } : item
    );
    setData(updatedData);
    setGroupedData(groupByModule(updatedData));
  }

  function handleAlertChange(event, name, id) {
    const updatedData = data.map((item) =>
      item.name === name && item.id === id ? { ...item, alertEnabled: event.target.checked } : item
    );
    setData(updatedData);
    setGroupedData(groupByModule(updatedData));
  }

  function handleAlertEmailChange(event, name, id) {
    const updatedData = data.map((item) =>
      item.name === name && item.id === id ? { ...item, emailEnabled: event.target.checked } : item
    );
    setData(updatedData);
    setGroupedData(groupByModule(updatedData));
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: "",
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      let noti = {
        data: data
      };
      const response = await editData(`/alert-settings/edit-alerts`, noti, resetForm, `/settings/notifications`);

      if (response?.data?.status === true) {
        getData();
      }
    }
  });

  const formatModuleName = (module) => {
  if (!module) return "";
  
  // Special cases
  if (module === 'tc') return "Testing & Commissioning";
  if (module === 'assign') return "Assignment";
  if (module === 'reassign') return "Re-Assignment";
  if (module === 'task') return "Task";
  if (module === 'ticket') return "Ticket";
  if (module === 'refilling') return "Refilling";
  if (module === 'inspection') return "Inspection";
  if (module === 'delete') return ""; 
  
 
  return module.charAt(0).toUpperCase() + module.slice(1);
};

  const formatLabel = (label) => {
      return label
      
  };

  return (
    <div className="w-full h-full px-4 py-2 overflow-hidden">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "Notifications",
            },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto p-2 rounded-md overflow-y-scroll">
        <HeadingWithIcon icon={BellDot} title="Notification List" />

        <form onSubmit={formik.handleSubmit}>
          <table className='w-full max-h-[calc(100vh-200px)] overflow-y-auto mt-2'>
            <thead>
              <tr className=''>
                <th className='w-[25%] text-left text-sm font-medium py-2 px-4'>Module</th>
                <th className='w-[25%] text-center text-sm font-medium py-2 px-4'>Alert</th>
                <th className='w-[25%] text-center text-sm font-medium py-2 px-4'>Email</th>
                <th className='w-[25%] text-center text-sm font-medium py-2 px-4'>Is Default</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedData).map(([module, items]) => {
                const displayName = formatModuleName(module);
                return (
                  <React.Fragment key={module}>
                    <tr className="bg-gray-100">
                      <td colSpan="4" className="py-2 px-4 font-bold text-sm">
                        {displayName}
                      </td>
                    </tr>
                    {items.map((value, index) => (
                      <tr className="bg-white" key={`${module}-${index}`}>
                        <td className="w-[25%] py-2 text-left text-sm px-4">
                          {formatLabel(value?.label)}
                        </td>
                        <td className="w-[25%] py-2 text-center text-sm px-4">
                          <label className="inline-flex items-center cursor-pointer overflow-hidden">
                            <input
                              type="checkbox"
                              checked={value?.alertEnabled === true}
                              onChange={(e) => handleAlertChange(e, value?.name, value?.id)}
                              className="sr-only peer"
                              hidden
                            />
                            <div className="relative w-9 h-5 bg-gray-200 rounded-full peer dark:bg-gray-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] peer-checked:after:bg-white after:bg-textColor-main after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-textColor-main"></div>
                          </label>
                        </td>
                        <td className="w-[25%] py-2 text-center text-sm px-4">
                          <label className="inline-flex items-center cursor-pointer overflow-hidden">
                            <input
                              type="checkbox"
                              checked={value?.emailEnabled === true}
                              onChange={(e) => handleAlertEmailChange(e, value?.name, value?.id)}
                              className="sr-only peer"
                              hidden
                            />
                            <div className="relative w-9 h-5 bg-gray-200 rounded-full peer dark:bg-gray-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] peer-checked:after:bg-white after:bg-textColor-main after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-textColor-main"></div>
                          </label>
                        </td>
                        <td className="w-[25%] py-2 text-center text-sm px-4">
                          <input
                            type="checkbox"
                            checked={value?.isDefault === true}
                            onChange={(e) => handleChange(e, value?.name, value?.id)}
                          />
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {GetAccess('notification_edit') &&
          <div className="w-full hidden md:block mx-auto my-4 mt-8">
            <div className="md:flex justify-end gap-4">
              <SubmitButton />
            </div>
          </div>}
        </form>
      </div>
    </div>
  )
}

export default MainNotification